<template>
  <Col
    :style="{
      'margin-bottom': '60px',
      'min-height': minHeight,
      overflow: 'hidden',
      'background': backgroundColor || backgroundImage,
      'background-size': backgroundImage ? '100%' : undefined,
      'background-position': backgroundImage ? 'center' : undefined,
      'background-size': 'cover',
    }">
    <Row type="flex" :justify="image ? 'start' : 'space-between'" class="hero large-side-margin" :style="{ 'padding-top': isMobile ? '100px' : '200px' }">
      <!-- Content -->
      <Col :style="{ width: contentWidth }" class="pad-against-pull-up">
        <h1 
          :class="{ 'text-shadow-img': backgroundImage, 'text-shadow': !backgroundImage && textShadow }"
          class="pad-content-row"
          style="padding-bottom: 0px;"
          :style="titleStyle">
          {{ title }}
        </h1>
        <h3
          :class="{ 'text-shadow-img': backgroundImage, 'text-shadow': !backgroundImage && textShadow }"
          class="pad-content-row">
          {{ description }}
        </h3>
        <Row class="pad-content-row">
          <GetStartedButton class="box-shadow"></GetStartedButton>
          <a href="#" v-scroll-to="{ el: '#hero-clearfix', offset: scrollOffset }" style="margin-left: 4px;">
            <Button class="box-shadow">Learn More <Icon type="arrow-down-c"></Icon></Button>
          </a>
        </Row>
      </Col>
      <!-- Image -->
      <Col class="pull-up">
        <Row style="width: 300px;">
          <img :src="image" :style="{ 'max-width': maxImageWidth }">
        </Row>
      </Col>
    </Row>
    <!-- Poly -->
    <Row :style="poly" v-if="slant">
    </Row>
    <!-- Anchor (for scroll-to) -->
    <Row id="hero-clearfix"></Row>
  </Col>
</template>
<script>
import GetStartedButton from './GetStartedButton';

const polyStyles = {
  content: '',
  display: 'block',
  width: '100%',
  // background: '#f8f8f9',
  background: '#fcfcfc',
  position: 'absolute',
  left: '0',
  bottom: '-1px',
  '-webkit-clip-path': 'polygon(100% 0,100% 0,100% 100%,0 100%)',
  'clip-path': 'polygon(100% 0,100% 0,100% 100%,0 100%)',
  'z-index': '1',
  height: '150px',
};

export default {
  components: { GetStartedButton },
  props: {
    isMobile: { type: Boolean },
    title: { type: String, required: true },
    description: { type: String },
    backgroundColor: { type: String },
    contentWidth: { type: String, default: '514px' },
    image: { type: String },
    backgroundImage: { type: String },
    minHeight: { type: String, default: '550px' },
    slant: { type: Boolean, default: true },
    scrollOffset: { type: Number, default: -90 },
    titleStyles: { type: Object },
    textShadow: { type: Boolean, default: true },
  },
  data() {
    return {
      // background: #263141;
      poly: Object.assign(polyStyles),
    };
  },
  computed: {
    maxImageWidth() {
      if (!this.image) { return '400px'; } // to give title more room on pages with no image
      return !this.isMobile ? '600px' : '80vw';
    },
    titleStyle() {
      const vm = this;
      return Object.assign({ 'font-size': '2rem' }, vm.titleStyles || {});
    },
  },
};
</script>
<style lang="css">
.hero {
  color: #fff;
  /*padding-top: 200px;*/
}

.hero h1 { font-size: 2rem; font-weight: 100; }
.hero h3 { font-size: 1rem; }

.large-side-margin {
  /*padding: 0 2vw;*/
  margin: 0 8.5vw;
}

.fixed-height {
  height: 480px;
}

.pull-up { top: -72px; }
.pad-against-pull-up { padding-bottom: 104px; }

.pad-content-row {
  padding: 6px 0;
}

#hero-clearfix {
  position: absolute;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Hero.vue